<template>
  <section v-if="customQuestions.length" class="donor-form-section donor-form-section-divider">
    <p class="donor-form-section-title">Additional questions</p>
    <div class="space-y-4">
      <fieldset v-for="(question, index) in customQuestions" :key="question.id" class="space-y-2">
        <legend class="text-sm font-medium text-gray-900">{{ question.text }}</legend>
        <div class="space-y-2">
          <label
            v-for="answer in question.answers"
            :key="answer.id"
            :for="answer.id"
            class="donor-form-question-option"
          >
            <input
              :id="answer.id"
              type="radio"
              :name="question.id"
              class="h-4 w-4 border-gray-300 text-primary focus:ring-primary"
              @input="getQuestionData(question, answer, index)"
            />
            <span>{{ answer.text }}</span>
          </label>
        </div>
      </fieldset>
    </div>
  </section>
</template>

<script>
import ApiService from '@/services/AxiosClient.js'
import { ref } from 'vue'

export default {
  name: 'DonorFormCustomQuestions',
  emits: ['questionData'],
  props: ['campaignApiUrl'],
  setup(_, { emit }) {
    const customQuestions = ref([])
    const questionData = ref([])

    return {
      customQuestions,
      questionData,
    }
  },
  mounted() {
    ApiService.get(this.campaignApiUrl).then((response) => {
      this.customQuestions = response.data.questions
    })
  },
  methods: {
    getQuestionData(question, answer, index) {
      const objIndex = this.questionData.findIndex((obj) => obj.question.text === question.text)

      if (objIndex !== index) {
        this.questionData.push({
          option: answer.id,
          question: {
            text: question.text,
            apiValue: question.api_value,
            answers: [answer],
          },
        })
      } else {
        this.questionData[objIndex].option = answer.id
        this.questionData[objIndex].question.text = question.text
        this.questionData[objIndex].question.answers = [answer]
        this.questionData[objIndex].question.apiValue = [question.api_value]
      }

      this.$emit('questionData', this.questionData)
    },
  },
}
</script>
